module.exports = __webpack_public_path__ + "static/media/IMG_2417.f032a24e.JPG";